import React, { lazy, Suspense } from 'react';
import { useAgencyCapabilities } from '../../shared/agency/AgencyEntry';
const Workspace = lazy(() => import('../../shared/agency/AgencyWorkspace'));

export default function AdminAgencyEntry({ onBack, onChat, onAccounting }) {
  const caps = useAgencyCapabilities();
  if (!caps) return <p role="status">Consultando acceso de administración…</p>;
  if (!caps.enabled || caps.role !== 'admin') return <div><button onClick={onBack}>Volver</button><p>No se pudo abrir operaciones de agencias. Comprueba la conexión y tus permisos.</p></div>;
  return <Suspense fallback={<p role="status">Cargando operaciones…</p>}><Workspace initialTab="overview" onBack={onBack} onChat={onChat} onAccounting={onAccounting} /></Suspense>;
}
